import {
  defaultThemeColors,
  deuteranopiaThemeColors,
  protanopiaThemeColors,
  themeColors,
  tritanopiaThemeColors,
} from '@ncr-retail/mui-theme';

/* the Emerald MUI theme extensions */
declare module '@material-ui/core/styles' {
  interface Theme {
    mainLogo: string;
    configColors: {
      primaryColor: string;
      primaryText: string;
      secondaryColor: string;
      secondaryText: string;
    };
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    mainLogo: string;
    configColors: {
      primaryColor: string;
      primaryText: string;
      secondaryColor: string;
      secondaryText: string;
    };
  }
}

/* theme colors */
export let themeColor = themeColors();
export const defaultThemeColor = defaultThemeColors();
/* color blind theme colors */
export const deuteranopiaThemeColor = deuteranopiaThemeColors();
export const protanopiaThemeColor = protanopiaThemeColors();
export const tritanopiaThemeColor = tritanopiaThemeColors();

export const setTheme = (colorPalette: any): void => {
  themeColor = themeColors(colorPalette);
};
